// extracted by mini-css-extract-plugin
export default {"logoPrincipal":"Proximamente_logoPrincipal__WV1yV","proximamente":"Proximamente_proximamente__0EOt2"};